import { useState, useEffect } from 'react';

export function MobileFloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show bar after scrolling past 100px
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleGetQuote = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const quoteSection = document.getElementById('quote');
    if (quoteSection) {
      quoteSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="bg-white/95 backdrop-blur-sm shadow-[0_-4px_20px_rgba(0,0,0,0.15)] flex">
        {/* Call Now Button */}
        <a
          href="tel:+13176482983"
          aria-label="Call Hoosier Life Insurance at (317) 648-2983"
          className="flex-1 flex items-center justify-center gap-2 py-4 font-bold text-white transition-colors hover:opacity-90"
          style={{ backgroundColor: '#1A3A52' }}
        >
          <i className="ri-phone-fill text-xl" aria-hidden="true"></i>
          <span>Call Now</span>
        </a>

        {/* Get Quote Button */}
        <a
          href="#quote"
          onClick={handleGetQuote}
          aria-label="Get a free life insurance quote"
          className="flex-1 flex items-center justify-center gap-2 py-4 font-bold text-white transition-colors hover:opacity-90"
          style={{ backgroundColor: '#D97642' }}
        >
          <i className="ri-file-text-fill text-xl" aria-hidden="true"></i>
          <span>Get Quote</span>
        </a>
      </div>
    </div>
  );
}

export default MobileFloatingCTA;